import { Box, Drawer, IconButton, Stack, Typography } from "@mui/material";
import Iconify from "../../../components/iconify";
import ShopCartPanel from "./ShopCartPanel";

export default function ShopCartDrawer({
  open,
  onClose,
  cartItems,
  setCartItems,
  cartTotal,
  cartTotalItems,
  onCheckout,
  creatingOrder,
  hasContractContext,
  checkoutDisabledMessage,
  checkoutContextNote,
  isMemberCatalogView,
  variantInventoryByKey,
}) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: { xs: "100%", sm: 380 }, maxWidth: "100vw" },
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ px: 2, py: 1.5, borderBottom: "1px solid", borderColor: "divider" }}
      >
        <Typography variant="h6" fontWeight={700}>
          Warenkorb
        </Typography>
        <IconButton onClick={onClose}>
          <Iconify icon="eva:close-fill" width={24} />
        </IconButton>
      </Stack>
      <Box sx={{ flexGrow: 1, overflow: "auto" }}>
        <ShopCartPanel
          cartItems={cartItems}
          setCartItems={setCartItems}
          cartTotal={cartTotal}
          cartTotalItems={cartTotalItems}
          onCheckout={() => {
            onCheckout();
            onClose();
          }}
          creatingOrder={creatingOrder}
          hasContractContext={hasContractContext}
          checkoutDisabledMessage={checkoutDisabledMessage}
          checkoutContextNote={checkoutContextNote}
          isMemberCatalogView={isMemberCatalogView}
          variantInventoryByKey={variantInventoryByKey}
          hideHeader
        />
      </Box>
    </Drawer>
  );
}
